import MoreVertIcon from "@mui/icons-material/MoreVert"
import { Menu } from "@mui/material"
import IconButton from "@mui/material/IconButton"
import { type MouseEvent, useEffect, useState } from "react"
import authService from "services/authService"
import type { IDevice } from "types/deviceTypes"
import { UserRoles } from "types/userRoles"
import { DeleteDeviceDialog } from "./DeleteDeviceDialog"
import { UpdateDeviceDialog } from "./UpdateDeviceDialog"

type Props = {
  device: IDevice
}

export function DeviceListItemMenu({ device }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [openMenu, setOpenMenu] = useState(false)
  const [roles, setRoles] = useState<Array<string>>()

  const handleClickMenuClose = () => {
    setAnchorEl(null)
    setOpenMenu(false)
  }

  const handleClickMenuOpen = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
    setOpenMenu(true)
  }

  useEffect(() => {
    authService.getRolesAssignedToUser().then((roles) => {
      setRoles(roles)
    })
  }, [])

  return (
    <>
      <IconButton aria-label="edit" size="small" onClick={handleClickMenuOpen}>
        <MoreVertIcon></MoreVertIcon>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClickMenuClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
      >
        <UpdateDeviceDialog device={device} />
        {roles?.includes(UserRoles.HIAB_ADMIN) && <DeleteDeviceDialog device={device} />}
      </Menu>
    </>
  )
}
